import { render } from "./New_MappingReferenceModal.vue?vue&type=template&id=45f7db16&scoped=true"
import script from "./New_MappingReferenceModal.vue?vue&type=script&lang=js"
export * from "./New_MappingReferenceModal.vue?vue&type=script&lang=js"

import "./New_MappingReferenceModal.vue?vue&type=style&index=0&id=45f7db16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f7db16"]])

export default __exports__